import { render, staticRenderFns } from "./invention-ready.vue?vue&type=template&id=1715a6ba&"
import script from "./invention-ready.js?vue&type=script&lang=js&"
export * from "./invention-ready.js?vue&type=script&lang=js&"
import style0 from "./invention-ready.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports